import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { StorageService } from '../services/storage.service';
import { RequestServices } from '../services/request.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { QuattroB2C } from '../models/quattroB2C.model';
import { Configuration, Encrypted } from '../constants/configuration';
import { LogConsumoB2C } from '../utilities/logConsumoB2C';

@Component({
    selector: 'app-login-ayuda',
    templateUrl: './login-ayuda.component.html'
})

export class LoginAyudaComponent implements OnInit {
    private quattroB2C: QuattroB2C = new QuattroB2C();
    public const: Configuration = new Configuration();
    public ec: Encrypted = new Encrypted();
    public logConsumoFunciones: LogConsumoB2C = new LogConsumoB2C(this.router, this.requestService, this.storageService);
    public logCon: string = "";


    constructor(private router: Router, private storageService: StorageService, private routers: ActivatedRoute, private requestService: RequestServices) {
    }

    ngOnInit(): void {

        this.routers.queryParams.subscribe(result => {
            if (result.logConsumoId) {
                sessionStorage.setItem("logConsumoIDB2C", result.logConsumoId);
                this.logCon = result.logConsumoId;
                if (this.logCon != new Encrypted().ZERO && this.logCon != "") {
                    this.consulta(this.logCon);
                }
            } else {
                console.error("Error: No params");
            }
        })
    }

    consulta(data: any) {
        let result: any = "";
        try {
            this.logConsumoFunciones.getLogJSON(data).subscribe(result => {
                if (result.error) {
                   // this.snackBar.open("Ocurrio un problema duarante el proceso", "", { duration: this.const.SNACK_BARTIME });
                } else if (result.result.json) {

                    this.quattroB2C = JSON.parse(result.result.json);
                    this.storageService.setItem("quattroB2C", JSON.stringify(this.quattroB2C));
                    // this.router.navigate([this.cocheSeguro.url]);
                    let productoIDEnc = this.quattroB2C.productoParametros?.b2cPortalProductoIDEnc || this.ec.ZERO;
                    this.requestService.getParameter(productoIDEnc, "1,2,7").then(res => {
                        if (res.find(p => p.parametroID == 2)) {
                            this.storageService.setItem("api-key", res.find(p => p.parametroID == 2)?.valorJson!);
                        }
                        if (this.const.PLATFORM) {
                            let urlAux: string = '';
                            if (window.location.hostname == 'localhost') {
                                urlAux = 'http://' + window.location.hostname + ':' + window.location.port;
                            } else {
                                urlAux = 'https://' + window.location.hostname;
                            }
                            window.location.href = urlAux + this.paso(this.quattroB2C.url!);
                        } else {
                            this.router.navigate([this.paso(this.quattroB2C.url!)]);
                        }
                    });
                }
            });

        } catch (error) {
            console.error("Error", error);
        }
    }


    paso(urls: string){
        
        try {
            let urls: string = "";
            switch (urls) {
                case "/autos":
                    urls = "/autos"
                    break;
                case "/cotizacion":
                    urls = "/cotizacion"
                    break;
                case "/datos-contratante":
                    urls = "/datos-contratante"
                    break;
                case "/autos/datos-autos":
                    urls = "/autos/datos-autos"
                    break;
                case "/datos-pago":
                    urls = "/datos-pago"
                    break;
                default:
                    break;
            }

        } catch (error) {
            console.error("Error paso", error)
        }
        return urls;
    }
}